<template>
  <span class="dimensions" v-if="value">
    <span class="dimensions__width">{{formattedWidth}}</span>
    <span class="dimensions__separator">×</span>
    <span class="dimensions__height">{{formattedHeight}}</span>
    <span class="dimensions__separator" v-if="formattedDepth">×</span>
    <span class="dimensions__depth" v-if="formattedDepth">
      {{formattedDepth}}
    </span>
    <span class="dimensions__unit">{{formattedUnit}}</span>
  </span>
</template>

<script>
export default {
  name: 'dimensions',
  props: {
    value: Object,
  },
  computed: {
    formattedWidth() {
      return this.$n(this.value.width);
    },
    formattedHeight() {
      return this.$n(this.value.height);
    },
    formattedDepth() {
      if (!this.value.depth) return null;
      return this.$n(this.value.depth);
    },
    formattedUnit() {
      return this.$t(`units.short.${this.value.unit}`);
    },
  },
  i18n: {
    messages: {
      de: {
        units: {
          short: {
            CM: 'cm',
            MM: 'mm',
            IN: 'in',
          },
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// Dimensions.vue?7680f01d